export default {
  packHeader: { batch:'{n}차',edit:'스타일 정보 수정',finish:'수정 완료',brandMismatch:'브랜드는 스타일 번호의 첫 두 자리와 일치해야 합니다.',categoryMismatch:'품목은 스타일 번호의 3–4번째 자리와 일치해야 합니다.',chooseGender:'목록에서 성별을 선택해 주세요.',supplierOwner:'공급업체는 생산관리 담당자가 입력합니다.',sourceChanged:'상위 자료가 변경되었습니다. 이 시스템의 수정은 유지되었으니 상품기획에서 확인해 주세요.' },
  orderInfo: { title: '발주 정보' },
  sizeImport: { selectFirst: '앞의 {max}개 선택' },
  manualStyle: {'title': '컬러 및 사이즈', 'sizes': '사이즈 범위', 'sizeInput': '사이즈 입력 후 Enter', 'sizesPending': '상품기획의 사이즈 설정 대기', 'manualOnly': '수동 스타일만 이 시스템에서 스타일 및 주문 정보를 수정할 수 있습니다.', 'sizeInUse': '이 사이즈에 자료가 있습니다. 해당 자료를 처리한 후 제거해 주세요.', 'colorInUse': '이 컬러에 자료가 있습니다. 해당 자료를 처리한 후 제거해 주세요.', 'unknownColor': '목록에서 컬러를 선택해 주세요.', 'chooseSize': '스타일의 사이즈 범위에서 기준 사이즈를 선택해 주세요.', 'chooseColor': '상품기획이 설정한 스타일 컬러를 선택해 주세요.', 'duplicate': '컬러와 사이즈는 중복될 수 없습니다.'},
  draftReview: {
    title: '자료가 변경되어 검토가 필요합니다', review: '변경 내용 검토', collapse: '접기',
    fieldsHint: '최신 자료에 유지할 입력 내용을 선택하세요.',
    structureHint: '행 또는 규격이 변경되었습니다. 입력 사본을 저장하고 최신 자료를 확인한 후 다시 입력하세요.',
    field: '항목', original: '기존 값', mine: '내 입력', latest: '최신 자료', keepMine: '내 입력 유지',
    useLatest: '최신 자료 사용', apply: '선택 적용', saveCopy: '입력 사본 저장', copyName: '미저장 입력',
    discardConfirm: '최신 자료를 사용하면 이 표의 미저장 입력이 대체됩니다. 계속하시겠습니까?', row: '{n}행', item: '{n}항목',
    parts: { sourceHeader: '스타일 원본 정보', supplierHeader: '공급업체', plannerStyle: '스타일·주문 정보', qc: 'QC', basicinfo: '스타일 정보', colorway: '배색', designmemo: '디자인 메모', orderinfo: '발주 정보', fabric: '원단', trim: '부자재', size: '치수', usageFabric: '원단 소요량 및 원가', usageTrim: '부자재 소요량 및 원가' },
    fields: { styleCd: '스타일 번호', styleNm: '품명', brandCd: '브랜드', originalStyleNo: '원스타일 번호', genderCd: '성별', productYear: '연도', season: '시즌', salesMonth: '판매월', finalGrade: '상품 등급', businessType: '업무 유형', productType: '상품 유형', styleKind: '스타일 종류', characteristic: '특성', productionCategory: '생산 품목', productionType: '생산 유형', mdpType: 'MDP 유형', mdpStartDate: 'MDP 시작일', salePrice: '판매가', quantities: '주문 수량', qty: '수량', people: '담당자', designerId: '디자이너', plannerId: '상품기획', purchasingId: '원부자재 구매', productionId: '생산관리', patternId: '패턴사', cadId: '패턴사', qcTypeCd: 'QC 유형', qcTypeNm: 'QC 유형명', factoryNm: '공장', countryCd: '생산지', krPicEmpNo: '한국 담당자 사번', krPicEmpNm: '한국 담당자', qcDate: '검사일', baseSizeCd: '기준 사이즈', resultCd: '검사 결과', resultNm: '검사 결과명', mainMaterial: '원단', mainBodyContent: '원단 혼용률', note: '비고', rejectSeq: '반려 횟수', rejectReason1: '반려 사유 1', rejectReason2: '반려 사유 2', rejectReasonMemo: '반려 설명', standardSpec: '기준 치수', sampleSpec: '실측 치수', qcDifference: '편차', side: '의견 출처', content: '의견', authorEmpNo: '작성자 사번', authorNm: '작성자', sizeChecks: '치수 실측', comments: 'QC 의견', samplePhase: '의뢰서 단계', stdSize: '기준 사이즈', stitchDensity: '땀수', remark: '비고', patternModuleNo: '패턴 모듈 번호', moduleModelCd: '모듈 의뢰서 번호', moduleStyleCd: '모듈 스타일 번호', contentKo: '한국어 메모', contentEn: '영문 메모', washingInfo: '워싱 정보', colors: '배색', cd: '색상 코드', nm: '색상명', receivingDueDate: '입고 요청일',
      categoryCode: '소분류', row: '행 정보', usedPartCd: '사용 부위', materialGroupCd: '원단 분류', materialCode: '원단 코드', materialNm: '원단명',
      materialAlias: '원단 별칭', materialMemo: '원단 비고', colorMatchPartCd: '배색 부위', tagColorCd: '적용 색상', tagColors: '적용 색상',
      vendorNm: '공급 업체', composition: '혼용률', finishing: '후가공', width: '폭', unit: '단위', yardage: '예상 소요량', realYardage: '실제 소요량',
      unitPrice: '단가', unitPriceCurrency: '통화', weight: '중량', weightUnit: '중량 단위',
      subMaterialTypeCd: '부자재 종류', subMaterialCd: '부자재 코드', contents: '부자재명', usedPart: '사용 부위', memo: '기술 비고',
      yardageUnit: '소요량 단위', isCommon: '전 색상 공통', bomGroup: '부자재 그룹', sizes: '사이즈 규격', sizeCd: '사이즈', gauge: '규격', gaugeUnit: '규격 단위',
      currency: '통화', isUsed: '사용', colorNm: '색상명', patternPartCd: '측정 부위 코드', patternPartNm: '측정 부위', measurement: '측정 방법',
      size: '기준 치수', values: '사이즈별 치수', value: '치수 값', tolLeft: '좌 편차', tolRight: '우 편차', tolPlus: '상 허용차', tolMinus: '하 허용차',
    },
  },
  sheetPhase: {
    PROTOTYPE: "평가회 · Prototype",
    TRADESHOW: "수주회 · TradeShow",
    MAIN: "본 생산 · Main",
  },
  sheetDetail: {
    samplePhase: "의뢰서 단계",
    recordVersion: "기록 버전",
    recordNo: "기록 {n}",
    expandNavigation: "메뉴 펼치기",
    collapseNavigation: "메뉴 접기",

    personNumberOnly: "사번 {no} (성명 미등록)",
    personUnassigned: "담당자 미지정",
    detailsAndPeople: "스타일 정보 및 담당자",
    assignees: "스타일 담당자",
    sourceDetails: "원본 정보",
    orderFair: "수주회",
    productNamePending: "상품명 미등록",
    patternOwner: "치수는 패턴사 {name} 님이 입력합니다. 현재 계정은 조회할 수 있습니다.",
    patternOwnerNamed: "치수는 패턴사 {name} 님이 입력합니다. 현재 계정은 조회만 가능합니다.",
    patternOwnerAnon: "치수는 패턴사가 입력합니다. 현재 계정은 조회만 가능합니다.",
    sections: "디자인 시트 내용",
    confirmed: "확인 완료",
    pending: "확인 대기",
    confirmedBy: "확인자: {name}",
    backToEdit: "작성으로 돌아가기",
    previousPage: "이전 페이지",
    nextPage: "다음 페이지",
    pageSelect: "미리보기 페이지",
    pageNo: "{n} / {total} 페이지",
    fitWidth: "너비 맞춤",
    preparingPrint: "내보내기 준비 중…",
    printHint: "9페이지 전체를 내보냅니다. 인쇄 창에서 PDF로 저장을 선택하고 A4 가로, 머리글·바닥글 없음으로 설정하세요. 인쇄물에는 가격이 포함되지 않습니다.",
    printFailed: "내보내기에 필요한 이미지 또는 글꼴을 준비하지 못했습니다. 연결 상태를 확인하고 다시 시도하세요. 현재 자료는 유지됩니다.",
    pendingItems: "최종 확인 전 보완 사항",
    uploadTargetChanged: "업로드 위치가 변경되었습니다. 대기 파일을 제거하고 위치를 확인한 후 다시 선택해 주세요.",
    uploadDestination: "업로드 위치: {name}",
    retryUpload: "업로드 재시도",
    discardFile: "대기 파일 제거",
    replaceFileHint: "새 파일의 업로드가 완료되면 기존 파일을 교체합니다.",
    libraryImage: "부자재 라이브러리 이미지입니다. 이 시트에 이미지를 업로드하면 해당 이미지를 우선 사용합니다.",
    recognitionSource: "인식 자료 원본",
    recognitionSourceHint: "파일 하나의 원부자재 자료를 선택해 검토하세요. 파일별 수정 내용은 각각 유지되며 이미지는 선택한 용도로 업로드합니다.",
    draftMismatch: "디자인 원고의 스타일 번호는 {draft}, 현재 스타일 번호는 {style}입니다. 현재 스타일의 참고 자료로 사용할 수 있는지 확인한 후 가져오세요.",
    draftMismatchTitle: "원고 스타일 번호 확인",
    useReference: "참고 자료로 가져오기",
    pageTarget: "{name} 가져오기 용도",
  },
  sheetEdit: {
    rowDeleted: '삭제됨',
    undoDelete: '삭제 되돌리기',

    autopending: "저장 대기",
    autosaving: "저장 중…",
    autosaved: "저장됨",
    autofailed: "저장 안 됨",
    recoveryAvailable: "저장되지 않은 내용이 있습니다. 현재 자료가 변경되었습니다.",
    recoverDraft: "미저장 내용 복원",
    useServerDraft: "현재 자료 사용",
    localDraftUnavailable: "로컬 임시 저장이 불가능합니다. 저장 완료 후 이동해 주세요.",

    unsavedTitle: '저장하지 않은 내용이 있습니다',
    leaveMessage: '현재 편집 영역을 벗어나면 저장하지 않은 수정 사항이 사라집니다. 계속하시겠습니까?',
    discardChanges: '수정을 버리고 계속',
    keepEditing: '계속 편집',
    prefillCloseMessage: '닫으면 이번에 선택한 원본과 미리 채우기 범위가 초기화됩니다. 계속하시겠습니까?',
    discardSelection: '이번 선택 버리기',
    savingWait: '저장 또는 업로드 중입니다. 잠시 기다려 주세요.',
    saveBeforeAction: '현재 수정 사항을 먼저 저장한 후 확인하거나 제출해 주세요.',
    importWriting: '검토한 원부자재 정보를 저장하고 있습니다…',
    importWriteFailed: '파일 {n}개는 저장되었지만 원부자재 정보는 아직 저장되지 않았습니다. 파일을 다시 올리지 않고 가져오기를 계속할 수 있습니다. 사유: {reason}',
    importUploadFailed: '파일 {n}개가 저장되었고 나머지는 아직 가져오지 않았습니다. 확인 후 계속해 주세요. 사유: {reason}',
    retryImport: '가져오기 계속',
    importDataOnly: '검토한 정보 저장',
    importCloseMessage: '아직 가져오지 않은 내용이 있습니다. 나머지를 버려도 이미 업로드한 파일은 의뢰서에 보관됩니다.',
    discardImport: '남은 내용 버리기',
    keepImporting: '계속 검토',
    recognitionKept: '{first}의 인식 결과를 유지했습니다. {next}는 이미지와 원본만 가져옵니다. 후자의 정보를 인식하려면 별도로 가져와 주세요.',
    retryFile: '다시 시도',
    sizesEmptyEditable: '아직 치수를 입력하지 않았습니다. 마스터에서 가져오거나 행을 추가하고 부위와 치수 값을 입력한 후 저장해 주세요.',
    sizesEmptyReadonly: '아직 치수가 없습니다. 패턴 담당자가 입력하며 현재 계정은 조회할 수 있습니다.',
    trimSaveStructure: '부자재 행의 추가·삭제 또는 순서를 먼저 저장한 후 이미지를 업로드해 주세요.',
    packNeedsRecheck: 'Tech Pack 재검토 필요',
    cancelOldConfirmation: '이전 확인 취소',
    stageOwner: '"{roles}" 담당 확인',
    stageConfirmedBy: '{name} 님이 {date}에 확인함',
    stageOwnerByRound: 'QC 담당은 회차별로 QC 상세 행에서 지정',
  },
  "ux": {
    "release0205": "수동 스타일 번호를 실제로 변경한 경우에만 이전 번호를 표시합니다. 시스템이 기록하며 읽기 전용입니다. 신규 생성과 일반 정보 수정에는 이전 번호가 생성되지 않습니다.",
    "release0204": "스타일을 불러오지 못하면 다시 불러올 수 있습니다. 배포 전에 빌드와 검사를 마쳐 서비스 중단을 줄이고 기존 스타일과 초안을 보존합니다.",
    "release0203": "게시한 수동 스타일을 수정 후 다시 게시할 수 있습니다. 후속 자료를 유지하고 색상·사이즈 충돌을 안내합니다.",
    "release0202": "수량 양식은 Excel 복사만 제공하며 입력 및 붙여넣기 안내를 정리했습니다.",
    "release0201": "시즌을 1–8로 정리하고 상품 색상을 코드와 영문명으로 표시합니다.",
    "release0200": "역할별 할 일과 페이지 목록, 신규 품번 생성, SAP 전송 전 수동 품번 수정, 브랜드별 상품 색상·품목별 사이즈 선택, 중국 E/B 원단 색상 적용.",
    "release0200rc1": "출시 후보 테스트 버전: 상품기획의 수동 스타일 생성과 주문 정보 관리, 여섯 담당 역할의 협업, 자료 수정 및 저장 보호를 지원합니다. 주문 정보 보완 시 기존 완료 확인을 유지하고 승인된 의뢰서에는 승인 요청 안내를 다시 표시하지 않습니다.",
    "release0193": "업로드한 도식화 위에서 교체하거나 삭제할 수 있습니다. PDF와 이미지를 다시 업로드할 수 있고 상세 이미지와 원본 파일의 추가·삭제 버튼을 항상 표시합니다.",
    "release0192": "디자인 영역 도구모음의 자료 업로드 버튼을 제거했습니다(각 업로드 영역 입구와 중복). 업로드와 PDF 분할은 이미지 자료 페이지의 각 영역에서 합니다.",
    "release0191": "원단 표는 원단 비고까지만 표시하고 폭·단위·소요량·가격은 소요량 및 원가에 모았습니다. 자동 저장 및 연속 저장 보호를 추가하고 Tech Pack 제목과 버튼을 각 단계의 공통 스타일로 통일했습니다.",
    "release0190": "원단과 부자재 내역을 소요량 및 원가에 모으고 원가 매개변수와 확정 스냅샷을 유지했습니다.",
    "release0180": "패턴 치수, 컬러웨이 표와 색상 선택을 개선하고 Tech Pack 상단 구조를 정리했습니다.",
    "release0170": "의뢰서 정보 카드와 승인 작업을 조정하고 기존 자료 복사 기능을 원부자재에 배치했습니다. 복사 시 단가는 제외합니다.",
    "release0169": "품명을 스타일 번호 뒤에 표시합니다. 정보 카드·목록·생성 대화상자의 임시 코드 표시를 제거했습니다(자리표시 번호의 재번호는 SP0120 대기).",
    "release0168": "정보 카드 행간을 조이고 제목 아래 품명 작은 글씨를 제거했습니다.",
    "release0167": "정보 카드 2행 6개 필드를 3행 담당자 6칸과 같은 폭으로 정렬하고, 1행 항목을 동일한 굵은 제목 형식으로 통일했습니다(스타일 번호는 여전히 가장 큼).",
    "release0166": "스타일 정보 카드를 3줄 구조로 변경했습니다. 브랜드·시즌·스타일·디자이너 / 의뢰 유형·번호·일자·소매가·사전원가·원가율 / 담당자 6인(소재·부자재 분리) 순이며 브랜드는 전체 이름을 표시합니다.",
    "release0165": "스타일 정보 카드를 재배치했습니다. 제목은 한 줄 전체를 차지하고 브랜드·연도·시즌·디자이너를 한 줄에, 나머지 속성은 4열, 6명 담당자는 하단 한 줄로 배치했습니다.",
    "release0164": "스타일 정보 카드를 정돈했습니다. 모든 필드를 라벨 위·값 아래로 통일하고 연도·시즌을 제목 옆 배지로 변경했으며 빈 값은 흐리게, 긴 값은 hover로 확인합니다. 오른쪽 위 TECH PACK 미리보기 버튼을 제거해 좌측 내비게이션으로만 이동합니다.",
    "release0163": "Tech Pack 화면 상단 정보 카드가 다른 영역과 동일하게 표시되며 사전 원가와 원가율이 다시 항상 나타납니다.",
    "release0162": "Tech Pack 화면이 다른 영역과 동일한 구조로 돌아왔습니다. 6개 영역 내비게이션이 왼쪽 원래 위치에 항상 표시되며 축소·분리되지 않습니다.",
    "release0161": "Tech Pack 미리보기의 번호 내비게이션을 떠 있는 막대로 변경해 미리보기 폭을 줄이지 않습니다. 콘텐츠 위치는 이전과 동일합니다.",
    "release0160": "디자인 영역을 이미지 자료와 메인정보 두 탭으로 재구성하고 업로드 입구를 하나로 통합했습니다. Tech Pack 미리보기에는 번호 내비게이션을 남겨 언제든 영역을 이동할 수 있으며, 보드 카드 정렬·생성 입구 상시 노출·로그인 후 이동 수정·메뉴 정리가 함께 반영되었습니다.",
    "release0154": "의뢰서 정보 카드를 스타일 정보와 6명 담당자로 나누었습니다. 판매가와 원가는 왼쪽에, 담당자는 두 줄로 항상 표시하며 6개 영역 탐색 폭을 줄여 편집 공간을 넓혔습니다.",
    "release0153": "디자인 영역에 FG 자료 업로드를 추가했습니다. 조회·교체 및 업로드 재시도를 지원하며 FG 이미지는 Tech Pack 표지에 도식화와 함께 표시합니다.",
    "release0152": "중국 전용 버전의 수량은 컬러와 사이즈별로 조회하며 국가별 수량 화면과 Tech Pack의 해당 페이지를 제거했습니다. 새 의뢰서는 중국 수량만 사용합니다.",
    "release0151": "의뢰서 상단에서 스타일 번호·상품명과 연도·시즌을 강조하고 수주회는 별도 항목으로 표시합니다. 원가와 판매가는 정보 영역에 통합하고 상세 정보 및 담당자 배치를 간결하게 정리했습니다.",
    "release0150": "의뢰서 편집 시 메뉴가 접히고 자료 가져오기는 디자인 영역에서 제공합니다. 자동 저장과 미저장 내용 복원, Tech Pack 연속 미리보기를 지원합니다. 평가회·수주회·본 생산 단계는 숫자 기록 버전과 별도로 관리합니다.",
    "release0142": "상세 화면의 빈 필드 정렬을 수정하고 중복된 업무 안내를 삭제했습니다. 첫 버전에서는 온라인 상품 정보와 USP·디자인 의도를 제공하지 않으며 미리 채우기, 디자인 승인 검사 및 자료 진행률에서도 제외했습니다.",
    "release0141": "내 업무 목록의 정렬을 개선했습니다. 모든 그룹의 열 너비와 머리글·내용 정렬을 통일하고 글자, 줄 간격, 셀 여백을 맞췄습니다. 좁은 화면에서는 모든 그룹을 함께 가로로 스크롤할 수 있습니다.",
    "release0140": "최종 주문 연동을 보완했습니다. 상품기획이 스타일별 패턴사를 배정하고 패턴사는 업무 목록에서 요척과 치수를 작성합니다. 연동 테스트는 지정 브랜드와 수주회에 한해 개통하며 전송 전 검사, 중복 전송 방지, 수신 이력 및 테스트 정보 수정을 유지합니다.",
    "release0130": "확인된 프로토타입에 따라 상세 화면과 Tech Pack을 개선했습니다. 메인 메뉴를 유지하고 작성 메뉴는 숨기며 페이지 선택 및 너비 맞춤을 제공합니다. 스타일 조회 권한으로 내보낼 수 있고 생산 관리가 최종 확인합니다. 이미지·글꼴 준비 후 인쇄하며 실패 시 재시도할 수 있습니다. 담당자 표시, 부자재 이미지, 업로드 및 여러 파일의 인식 자료 선택도 개선했습니다.",
    "adminTitle": "시스템 관리",
    "adminDesc": "담당자와 역할을 관리하고 업무 연결 상태를 확인하며 사용자 관점으로 업무 흐름을 테스트합니다.",
    "adminCounts": "계정 {users}개, 역할 {roles}개가 설정되어 있습니다.",
    "loadFailed": "관리 정보를 불러올 수 없습니다. 잠시 후 새로고침하세요.",
    "manage": {
      "brands": "브랜드 관리",
      "users": "사용자 관리",
      "roles": "역할 권한",
      "connections": "업무 연결",
      "about": "시스템 정보",
      "assignments": "스타일 담당자"
    },
    "manageDesc": {
      "brands": "현재 브랜드를 등록하고 사용 설정하여 업무 자료의 조회 범위를 관리합니다.",
      "users": "역할, 조회 가능한 브랜드와 계정 상태를 설정합니다.",
      "roles": "역할별 권한을 설정합니다. 같은 역할은 같은 권한을 사용합니다.",
      "connections": "자료 조회, 의뢰서 전송 및 업무 수신 상태를 확인합니다.",
      "about": "소프트웨어 버전, 변경 이력과 향후 계획을 확인합니다.",
      "assignments": "준비된 스타일에 담당자를 지정하고 배정 현황을 확인합니다."
    },
    "testGuideTitle": "출시 전 업무 테스트",
    "testGuide": "상단의 테스트 사용자 전환에서 담당자를 선택해 업무와 권한을 확인하세요. 선택한 사용자의 업무 권한을 적용하며 실제 조작자도 기록합니다. 완료 후 관리자로 돌아오세요.",
    "testView": "테스트 사용자 전환",
    "allBrands": "전체 브랜드",
    "testingAs": "테스트 사용자: {name}",
    "returnAdmin": "관리자로 돌아가기",
    "language": "화면 언어",
    "rolesTitle": "역할 권한",
    "rolesDesc": "역할별 업무 권한을 설정합니다. 사용자 관리에서 각 사용자에게 하나의 역할과 조회 브랜드를 지정하세요.",
    "roleMembers": "사용자 {count}명",
    "adminProtected": "관리자 권한은 계정 관리 접근을 유지하도록 시스템에서 관리합니다.",
    "roleEffect": "저장하면 해당 역할의 모든 사용자에게 즉시 적용됩니다.",
    "saveRole": "역할 권한 저장",
    "saved": "역할 권한을 저장했습니다.",
    "discardPermissions": "저장하지 않은 변경 사항을 취소하시겠습니까?",
    "roleSaveConfirm": "{role} 역할의 권한을 변경합니다. 사용자 {count}명에게 적용됩니다. 저장하시겠습니까?",
    "responsibilities": "자료 담당 및 승인 규칙 보기",
    "permissionGroup": {
      "sheet": "의뢰서 및 디자인 승인",
      "spec": "소재 및 치수",
      "qc": "품질 검사",
      "sap": "의뢰서 전송",
      "cost": "원가 설정",
      "submaterial": "부자재 라이브러리",
      "master": "기초 자료",
      "integration": "업무 연결 점검",
      "admin": "시스템 관리",
      "responsibility": "담당자 배정"
    },
    "tasksTitle": "내 업무",
    "designerJourney": "배정된 스타일에서 시작하세요. 디자인 자료를 가져오거나 기존 의뢰서에서 채운 후 확인 및 보완하여 디자인 승인을 요청합니다.",
    "parallelTasks": "담당 스타일의 자료를 보완합니다. 디자인, 원부자재 구매 및 생산 준비는 병행할 수 있습니다.",
    "myAssignments": "내게 배정된 의뢰서",
    "brandSheets": "브랜드 전체 의뢰서",
    "mineOnly": "내 업무만 보기",
    "prepareTask": "테스트 업무 준비",
    "businessType": "업무 유형",
    "designStatus": "디자인 승인 상태",
    "nextAction": "다음 작업",
    "unassigned": "담당자 지정 필요",
    "noAssignedTasks": "조건에 맞는 업무가 없습니다. 브랜드 전체 의뢰서를 확인할 수 있습니다. 선행 업무가 확정되면 새 업무가 배정됩니다.",
    "designApproved": "디자인 승인 완료",
    "nextPurchase": "원부자재 규격과 단가를 보완하고 구매 자료 확인",
    "nextPattern": "기준 치수와 원부자재 요척 보완",
    "technicalNext": { "trimBom": "부자재 기술 정보 입력", "size": "기준 치수 입력", "cost": "원부자재 요척 입력", "deviation": "치수 편차 입력" },
    "technicalComplete": "담당 기술 자료 완료",
    "nextProduction": "생산 자료 검토 및 Tech Pack 최종 확인",
    "connectionsTitle": "업무 연결",
    "connectionsDesc": "최근 업무 결과와 연결 진행 상황을 확인합니다. 과거 성공 기록과 네트워크 점검은 각각 구분해 표시합니다.",
    "refreshRecords": "기록 새로고침",
    "sapRead": "스타일 자료 조회",
    "sapReadDesc": "스타일 번호로 색상, 사이즈, 기획 수량 등을 조회합니다.",
    "sapSend": "의뢰서 전송",
    "sapSendDesc": "확인된 의뢰서를 업무 시스템으로 전송합니다. 실패하면 원인 확인과 재검증이 필요합니다.",
    "hasSuccessRecord": "성공 기록 있음",
    "notVerified": "검증 전",
    "sendNeedsFix": "최근 전송 실패 · 조치 필요",
    "lastSuccess": "최근 성공 기록: {at}",
    "lastRecord": "최근 업무 기록: {at}",
    "finalOrders": "신규 스타일 업무 · 대량 생산",
    "finalOrdersDesc": "상품기획이 확정한 최종 발주 결과를 받아 스타일 업무를 생성합니다. 10월 7일 내 양측 연동 테스트 완료를 목표로 합니다.",
    "orderLookupSeparate": "기존 수주회 조회는 자료 준비에 사용할 수 있습니다. 최종 결과 전송은 별도 연동이 필요합니다.",
    "awaitIntegration": "연동 대기",
    "reorders": "추가 발주 업무 · 5일",
    "reordersDesc": "자사 분석의 추가 발주 제안을 수신합니다. 상위 시스템을 개선 중이며 연결 일정은 아직 미정입니다.",
    "planned": "연동 예정",
    "networkTitle": "자료 통신 경로 점검",
    "networkScope": "네트워크 연결만 확인합니다. 업무 자료를 조회 또는 전송하지 않으며 업무 계정을 검증하지 않습니다.",
    "networkOk": "네트워크 경로 연결 가능",
    "networkFailed": "현재 연결할 수 없습니다. 유지보수 담당자에게 문의하세요.",
    "checkNetwork": "네트워크 경로 점검",
    "sapConfigured": "연결 설정 완료",
    "sapNotConfigured": "연결 설정 미완료",
    "technicalDetails": "유지보수 진단 상세",
    "currentStatus": "현재 사용 가능 범위",
    "currentStatusDesc": "테스트 버전은 주문 수신, 개별 및 일괄 스타일 생성, 자료 가져오기와 수정, 디자인 승인 및 Tech Pack을 지원합니다. 상품기획이 다섯 담당 역할을 관리하며 패턴사가 기술 자료를 완성합니다. 관리자가 브랜드별 디자인 승인자를 지정합니다. 기업 위챗 로그인을 연결했으며 직원 계정은 설정에 따라 단계적으로 활성화합니다. SAP 조회는 검증했으나 의뢰서 전송은 연동 검수가 필요합니다.",
    "futurePlan": "향후 계획",
    "futurePlanDesc": "ND와 EE의 역할별 화면 및 PDF 검수, 정식 담당자 배정과 SAP 전송 대조를 완료합니다. 10월 말 안정성 테스트 후 독립 도메인으로 이전하며 상위 시스템 담당자 계정 매핑과 추가 발주 제안을 계속 연결합니다. 온라인 상품 정보와 USP·디자인 의도는 후속 개선과 검수 후 제공하며 다단계 승인과 의뢰서 개정은 별도로 확인합니다.",
    "release0222": "페이지별 글자 크기, 줄 높이, 표와 버튼 스타일을 통일하고 작업 간격과 안내 문구의 대비를 조정했습니다. 파일 선택과 행별 작업을 개선했습니다.",
    "release0221": "로그인 페이지의 상단 내비게이션과 저작권 정보를 정리하고 프로젝트 소개·기업 위챗 로그인 안내를 보완했습니다.",
    "release0220": "디자인 스튜디오 로그인 홈을 적용하고 스튜디오 이미지와 굵은 design, 가는 sheet 워드마크를 사용합니다. 기업 위챗 QR 로그인을 유지합니다.",
    "release0212": "Design Sheet 로그인 페이지에 기업 위챗 QR 코드를 표시하며 로그인 후 원래 페이지로 돌아갑니다. QR 새로고침과 대체 로그인 경로를 제공합니다.",
    "release0211": "관리자가 테스트 보기로 전환한 후에도 본인의 기업 위챗 로그인 상태를 확인합니다. 포털에서 로그아웃하거나 계정이 변경되면 테스트 세션이 종료됩니다.",
    "release0210": "SAP 템플릿 일괄 스타일 생성, 기업 위챗 로그인과 직원 계정 연결을 추가했습니다. 패턴사가 기술 자료를 통합 담당하며 관리자가 브랜드별 디자인 승인자를 변경할 수 있습니다. 전송 결과 대조, 중복 전송 방지 및 브랜드별 로그 접근을 강화했습니다.",
    "releaseHistory": "소프트웨어 변경 이력",
    "release010": "관리자 전용 홈, 역할 권한 설정, 기간 제한 테스트 사용자 전환, 담당 업무 목록 및 업무 연결 안내.",
    "release012": "최종 주문 수신, 전송 전 검사와 중복 전송 방지를 추가하고 브랜드 및 기본 업무 배정에 따라 업무를 생성합니다. 테스트 기간에는 정보를 수정하거나 잘못된 수신을 철회할 수 있으며 원본과 수정 이력을 보관합니다.",
    "release0121": "주문 업무에 확정된 업무 품목을 표시합니다. 담당자가 모두 지정된 경우 상품기획에 품목 보완을 요청하지 않으며, 담당자를 변경해도 기존 분류를 유지합니다.",
    "release0122": "빈 치수의 완료 표시, 정보 변경 후 재확인, 편집 초안 보호, 저장 상태와 가져오기 실패 복구를 수정했습니다. 부자재 이미지는 원래 행을 따라 연결되며 원부자재 용어를 통일했습니다. Tech Pack 새 레이아웃과 내보내기 범위는 프로토타입 확인을 기다립니다.",
    "release011": "브랜드 관리와 사용 중인 브랜드의 접근 범위를 적용합니다. 상품기획이 기본 업무 배정 및 스타일 담당자를 관리하며, 발주 수량은 조회만 하고 중복 확인을 없앱니다.",
    "release091": "배포 경로의 로그인과 세션 갱신 요청 수정, 시작 및 실제 환경 점검 추가.",
    "release090": "첫 테스트 버전 출시. 의뢰서, 승인, 소재 및 Tech Pack 기능 제공.",
    "build": "빌드",
    "demoNotice": "시연 자료: 업무 테스트용이며 실제 생산의 근거로 사용하지 않습니다.",
    "startMaterials": "디자인 자료 가져오기",
    "peopleTitle": "스타일 담당자",
    "assignPeople": "스타일 담당자 지정",
    "assignPeopleDesc": "스타일별 디자이너, 상품기획, 원부자재 구매 및 생산관리 담당자를 한 명씩 지정합니다. 원단과 부자재는 같은 구매 담당자가 맡습니다.",
    "packReadiness": "Tech Pack 준비 확인",
    "packOwner": "아래 확인이 완료되면 생산관리 담당자가 미리보기를 검토하고 최종 확인합니다.",
    "packReady": "자료 확인이 완료되었습니다. 미리보기를 검토한 후 최종 확인하세요.",
    "waitDesignApproval": "디자인 승인 대기",
    "finalConfirm": "Tech Pack 최종 확인",
    "finalConfirmed": "Tech Pack 최종 확인 완료",
    "waitProductionConfirm": "생산관리 최종 확인 대기",
    "confirmPack": "미리보기의 자료를 검토했는지 확인하세요. 이후 자료를 변경하면 이번 확인은 취소되며 다시 확인해야 합니다.",
    "demoPack": "시연 자료",
    "draftPack": "최종 확인 전",
    "loadTasksFailed": "업무를 불러오지 못했습니다. 다시 시도하세요.",
    "clearFilters": "대기 업무 필터 해제",
    "assignmentsTitle": "스타일 담당자",
    "assignmentsDesc": "준비된 의뢰서에 네 명의 핵심 담당자를 지정합니다. 각 담당자의 업무 목록에 동시에 표시됩니다.",
    "testViewEnded": "테스트 관점이 종료되어 관리자로 돌아왔습니다. 테스트 기간 중에는 사용자를 다시 선택할 수 있습니다.",
    "taskNotifications": "업무 알림",
    "pendingCount": "처리가 필요한 스타일 {count}개",
    "allTasks": "전체 업무 보기",
    "trimPreview": "부자재 {code} 이미지 보기",
    "noTaskAccess": "현재 계정에 업무 역할 또는 의뢰서 조회 권한이 설정되지 않았습니다. 관리자에게 문의하세요.",
    "nextPlan": "필요 시 스타일 담당자 조정",
    "nextReview": "디자인 자료 검토",
    "orderLookupReady": "수주회 자료 조회가 설정되어 있습니다. 실제 조회 확인이 필요합니다.",
    "orderLookupMissing": "수주회 자료 조회에 필요한 연결 정보가 없어 현재 사용할 수 없습니다."
  }
};
